 
import CONQUER from "../../CONQUER";
import { ACTIONS } from "../../../Models/ENUM";
import PlayerInventory from "./PlayerInventory";
import LOG, {log} from "../../../UTIL/LOG";
import GameInstance from "../GameInstance";
import InventoryTab from "./InventoryTab";
import ARRAY from "../../../UTIL/ARRAY";
import ShopItem from "../SHOP/ShopItem";

class InventoryItem
{
    public isSelected       : boolean;
    public inventoryID      : any;
    public key              : string;
    public data             : any;
    public tabKey           : string;
    public isLocked         : boolean;
    public symbol           : string;
    public description      : string;
    public title            : string;
    public rarity           : string;
    public sorting          : number = 0;

    public canLevelUp       : boolean = false;
    public level            : number = 0;
    public amount           : number = 0;
 
    private gameInstance    : GameInstance;
    private vars            : any;
    public shopItem         : ShopItem;

    private levelUpTable    : any = [ 0, 3, 5, 10, 25  ];
 
    constructor( gameInstance:GameInstance, vars:any )
    {
        this.gameInstance   = gameInstance;

        this.inventoryID    = vars.inventoryID;
        this.key            = vars.key;
        this.isLocked       = vars.isLocked;
        this.isSelected     = vars.isSelected || false;

        this.vars           = vars;

        this.shopItem       = gameInstance.Shop.items[ this.key ];

        this.data           = this.shopItem.data;
        this.symbol         = this.shopItem.symbol;
        this.tabKey         = this.shopItem.tabKey;
        this.title          = this.shopItem.title;
        this.description    = this.shopItem.description;
        this.rarity         = this.shopItem.rarity;
        this.sorting        = this.shopItem.sorting;
 
    }

    public select() 
    {
        //log("InventoryItem select", this.key, this.isSelected );

        if( this.isSelected ) return;

        //log( "InventoryItem select", this.key, "SELECTED!!!" );

        this.isSelected = this.vars.isSelected = true;
        //this.isLocked   = this.vars.isLocked = false;
        this.gameInstance.Data.set( this.inventoryID, this.vars );
        this.gameInstance.Inventory.tabs[ this.tabKey ].select( this.key );

        this.gameInstance.Signal.set( "INVENTORY:onUpdate", { tab:this.tabKey, inventoryItem:this } );
 
        return this;
    }

    public async deselect() : Promise<any> 
    {
      //  log("deselect item-", this.key, this.selected );
        if( !this.isSelected ) return;

        this.isSelected = this.vars.isSelected = false;
        this.gameInstance.Data.set( this.inventoryID, this.vars );
    }

    public remove()
    {
        this.gameInstance.Inventory.remove( this );
    }

    public unlock()
    {
        if( !this.isLocked ) return;
        
        this.isLocked = this.vars.isLocked = false;
        this.gameInstance.Data.set( this.inventoryID, this.vars );

        let tab : InventoryTab = this.gameInstance.Inventory.tabs[ this.tabKey ];

        ARRAY.removeItem( tab.locked, this );
        ARRAY.pushUnique( tab.unlocked, this );
 
        return;
    }

}

export default InventoryItem;